<div class="pr-6 pr-96px pt-3" role="main" aria-label="MyHistory" *ngIf="outcome">
  <h1 class="h-1 mb-2-4rem-imp">{{history}}</h1>
  <mat-form-field class="mb-28px" appHostListenerClick>
    <mat-label>{{showHistoryFor}}</mat-label>
    <mat-select (selectionChange)="updateHistory()" #feedBackTypeSelect class="dropdownValue" autofocusdropdown="true" placeholder="show history" formControlName="showhistorydefault" [formControl]="showhistorydefault" disableOptionCentering>
      <mat-option class="dropdownValue" *ngFor="let type of showhistorylist" [value]="type">{{type}}</mat-option>
    </mat-select>
  </mat-form-field>
  <table mat-table [dataSource]="dataSource" matSort matSortActive="Date" matSortDirection="desc" aria-describedby="myhistory1">
    <ng-container matColumnDef="Date">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{date}}</th>
      <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='Date'?'#F0F5FF':null"> {{element.Date | date: 'MM/dd/yyyy'}} </td>
    </ng-container>

    <ng-container matColumnDef="Vieweditem">
      <th scope="col" mat-header-cell *matHeaderCellDef>{{VieweditemTitle}}</th>
      <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='Vieweditem'?'#F0F5FF':null">
        <span *ngIf="element.Type != 'Annotation'">
          <span *ngFor="let items of element.Vieweditem.split('~'); let i = index">
            <span *ngIf="items != element.Vieweditem.split('~')[0] && items != element.Vieweditem.split('~')[element.Vieweditem.split('~').length -1]">
              {{items | shortText : 30}} <img *ngIf="i != element.Vieweditem.split('~').length-2" class="arrow" src="../../../assets/icons/Arrow Right (Alt).svg" alt="Arrow Right" />
            </span>
           </span>
          <span *ngIf="element.Vieweditem.split('~').length > 2">
            <span><img class="arrow" src="../../../assets/icons/Arrow RightDown (Alt).svg" alt="Arrow Right Down"></span><br />
          </span>
          <span class="highlight-blue border-bottom-help cursor-pointer" (click)="RedirectToVisitedPage(element)">
            <span >{{element.Vieweditem.split('~')[element.Vieweditem.split('~').length - 1]}}</span>
          </span>

        </span>
        <span *ngIf="element.Type == 'Annotation'">
          <img src="../../../assets/icons/pencil-alt.svg" class="whatsNew-image" alt="Annotation">&nbsp;
          <span class="highlight-blue border-bottom-help cursor-pointer" (click)="RedirectToVisitedPage(element)">
            {{element.Vieweditem}}
          </span>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="Area">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{area}}</th>
      <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='Area'?'#F0F5FF':null"> {{element.Area }} </td>
    </ng-container>
    <ng-container matColumnDef="Type">
      <th scope="col" mat-header-cell *matHeaderCellDef mat-sort-header>{{type}}</th>
      <td mat-cell *matCellDef="let element" [style.background-color]="sort?.active=='Type'?'#F0F5FF':null"> {{element.Type}} </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
  <div *ngIf="dataSource.data.length === 0" class="align-items-center text-align-norecords">{{noRecords}}</div>
  <div>
    <mat-paginator [pageSize]="pagesize" [pageSizeOptions]="pagelistarray"
                   aria-label="Select page of bookmarks">
    </mat-paginator>
  </div>

</div>
